<template>
  <div>
    <a-card size="small" title="系统配置">
        <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>

        <searchE @handleSearch="handleSubmit"></searchE>

        <tableE ref="cpuTableID"></tableE>
    </a-card>

     
  </div>
</template>
<script>

import searchE from './search'
import tableE from './table'
export default {
    data() {
        return {
            searchP:{},
        };
    },
    methods: {
        handleSubmit(searchP){
            this.$refs.cpuTableID.handleSearch(searchP);
        },
        handleNew(){
            this.$router.push({
                path: "add_jenkins",
                query: {id:''}
            });
        },
    },
    components:{
        searchE,
        tableE
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
